import { Dialog, DialogContent } from "@mui/material";

export const DialogWrapper = ({ open, onClose, children }) => {
  return (
    <Dialog
      style={{ zIndex: 100001 }}
      maxWidth="lg"
      open={open}
      onClose={onClose}>
      <DialogContent>
        {children}
      </DialogContent>
    </Dialog>
  );
};